import {css} from 'lit';

import {defaultStyles} from '../../../components/text.js';

export const styles = defaultStyles.extends({
  statics: css``,
  colorGen: () => '',
  gradientGen: () => '',
  fontGen: () => '',
  textGen: () => '',
  weightGen: () => '',
  alignGen: () => '',
});

export default {styles};
